import arrowSmallIcon from "@assets/icons/arrow-up-s-fill.svg";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "@layouts/Header";
import BusinessHeader from "../components/business-header";

const list = [
  "Service Availability",
  "Emergency Response Standards",
  "Scheduled Maintenance",
  "New Connection SLA",
  "Meter Reading & Billing SLA",
  "Online Services SLA (Portal & App)",
  "Customer Service SLA",
  "Safety & Compliance SLA",
  "Limitations & Exclusions",
  "Customer Responsibilities",
  "Review & Updates",
  "Contact for SLA Queries",
];

const ServiceLevelAgreement = () => {
  const location = useLocation();
  const isBusiness = location.pathname.startsWith("/business");

  return (
    <div className="bg-[#F1F1F1]">
      {/* HERO SECTION */}
      <section className="bg-[#82716E] relative overflow-hidden">
        <div className="w-full max-w-[1728px] mx-auto flex flex-col items-start pt-8 px-5 md:px-10 lg:px-[121px] pb-[74px]">
          <div className="w-full relative z-10">
            {isBusiness ? <BusinessHeader /> : <Header />}
          </div>
          <div className="w-full max-w-[1368px] mx-auto text-center mt-12 md:mt-20">
            <h1 className="text-[35px] md:text-[56px] lg:text-[76px] font-bold tracking-[-0.04em] text-white leading-[1.1]">
              Service Level Agreement (SLA)
            </h1>
            <p className="w-full mt-3 text-xs md:text-base lg:text-[24px] tracking-[-0.04em] text-white/75 leading-[1.4]">
              This Service Level Agreement (SLA) defines the service standards,
              performance commitments, responsibilities, and support levels
              governing the delivery of our gas services.
            </p>
          </div>
        </div>
      </section>

      <section className="pt-10 md:pt-[60px] pb-[120px] px-5 md:px-10">
        <div className="w-[1368px] max-w-full mx-auto space-y-3 md:space-y-6">
          <List title="Introduction" index={1}>
            <p className="text-[14px] md:text-sm lg:text-lg">
              This Service Level Agreement (SLA) defines the service standards
              that GAS Integrated Solutions L.L.C. (“GASIS”, “we”, “our”, “us”)
              commits to delivering across all gas-related operations, customer
              interactions, and digital services. The purpose of this SLA is to
              ensure clarity, transparency, and reliability for all customers
              and partners.
            </p>
          </List>
          <List title="Scope of the SLA" index={2}>
            <p className="text-[14px] md:text-sm lg:text-lg font-medium">
              This SLA applies to the following GASIS services:
            </p>

            <div className="mt-2 space-y-2">
              {[
                "Periodic inspection and preventive maintenance programs",
                "Pressure testing and leak audits",
                "Equipment replacement and calibration",
                "24/7 emergency response with guaranteed SLA (≤ 60 minutes)",
                "Digital maintenance reports accessible via portal ",
              ].map((feature, index) => (
                <li key={index} className="flex items-center gap-3">
                  <span className="flex-shrink-0 size-2 md:size-3 bg-[#62636C] rounded-full" />
                  <span className="text-[#62636C] text-[14px] md:text-sm lg:text-lg">
                    {feature}
                  </span>
                </li>
              ))}
            </div>
          </List>

          {list.map((li, index) => (
            <List title={li} index={index + 2}>
              <p className="text-[14px] md:text-sm lg:text-lg font-medium">
                Content goes here
              </p>
              <p className="text-[14px] md:text-sm lg:text-lg font-medium">
                Content goes here
              </p>
              <p className="text-[14px] md:text-sm lg:text-lg font-medium">
                Content goes here
              </p>
              <p className="text-[14px] md:text-sm lg:text-lg font-medium">
                Content goes here
              </p>
            </List>
          ))}
        </div>
      </section>
    </div>
  );
};

const List = ({
  children,
  title,
  index,
}: {
  title: string;
  index: number;
  children: React.ReactNode;
}) => {
  const [open, setOpen] = useState(index === 1 ? true : false);

  return (
    <article className="p-3 md:p-6 bg-white rounded-[12px] md:rounded-[24px]">
      <div
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center justify-between gap-5 cursor-pointer"
      >
        <div className="flex items-center gap-3">
          <div className="bg-black size-10 md:size-[56px] grid place-content-center rounded-[12px]">
            <span className="text-sm font-semibold text-white md:text-base lg:text-lg">
              {index >= 10 ? index : `0${index}`}
            </span>
          </div>

          <h3 className="text-[#1C1C1C] text-sm md:text-base lg:text-xl font-semibold">
            {title}
          </h3>
        </div>

        <img
          src={arrowSmallIcon}
          alt="arrow icon"
          className={`transition-transform duration-300 ${
            open ? "" : "rotate-180"
          }`}
        />
      </div>

      {/* GRID COLLAPSIBLE SECTION */}
      <div
        className={`grid transition-all duration-300 ease-in-out ${
          open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
        }`}
      >
        <div className="overflow-hidden">
          <div className="md:px-16 border-[#B9BBC6] border-t pt-4 mt-4">
            {children}
          </div>
        </div>
      </div>
    </article>
  );
};

export default ServiceLevelAgreement;
